<template>
  <div style="width: 100%">
    <v-row class="align-center">
      <v-col
        md="5"
        class="mb-0 pb-3 flex-grow-1"
        style="min-width: 100px; max-width: 100%"
        ><v-btn
          md="5"
          class="white--text rounded-card"
          color="fiscButton"
          @click="routeToReceipts"
          id="routeReceiptsBtn"
          v-if="
            unfiskReceipts.length !== 0 && !$route.name.includes('receipts')
          "
          >Broj nefiskaliziranih računa: {{ unfiskReceipts.length }}
        </v-btn>
      </v-col>
      <v-col
        cols="10"
        sm="11"
        md="7"
        lg="5"
        xl="4"
        style="min-width: 100px; max-width: 100%"
        class="d-flex align-center justify-end flex-sm-grow-1"
      >
        <!-- <v-text-field
          @click="showKbd"
          data-layout="normal"
          append-icon="mdi-magnify"
          clearable
          class="pr-5 pt-5"
          :style="{ 'max-width': $vuetify.breakpoint.mdAndUp ? '50%' : '100%' }"
          v-model="topSearch"
          v-if="$route.meta.removeSearch ? false : true"
          @input="filterItems()"
          @click:clear="
            filterItems({ reset: true });
            searchItems({ reset: true });
          "
          @click:append="searchItems()"
          :placeholder="
            $route.meta.filterSearch
              ? $t('$vuetify.filterPlaceholderLabel')
              : $t('$vuetify.searchLabel')
          "
          @keydown.enter="searchItems()"
        >
        </v-text-field> -->
        <!-- <v-tooltip bottom>
          <template
            v-if="$route.meta.removeGrid ? false : true"
            v-slot:activator="{ on, attrs }"
          >
            <v-btn v-on="on" v-bind="attrs" plain text @click="changeView">
              <v-icon v-if="listView">mdi-view-grid</v-icon>
              <v-icon v-else>mdi-view-list</v-icon>
            </v-btn>
          </template>
          <span>{{ listView ? "Prikaži kao grid" : "Prikaži kao listu" }}</span>
        </v-tooltip> -->
      </v-col>
    </v-row>
    <v-container
      class="kbd"
      v-if="!$vuetify.breakpoint.smAndDown"
      ref="keyboard"
      v-show="oskVisible"
      :style="{ 'max-width': width }"
    >
      <div class="kbd-header"></div>
      <vue-touch-keyboard
        :options="oskOptions"
        :layout="layout"
        :cancel="hideKbd"
        :accept="accept"
        :input="input"
      />
    </v-container>
  </div>
</template>
<script>
import state from '@/state'
import applicationSettings from '@/mixins/applicationSettings'
import { df } from '@/plugins/firebase'
import onScreenKeyboard from '@/mixins/onScreenKeyboard'

export default {
  name: 'PointOfSaleTopBar',
  mixins: [applicationSettings, onScreenKeyboard],
  data: function () {
    return {
      topSearch: '',
      unfiskReceipts: [],
      listeners: []
    }
  },
  beforeDestroy () {
    if (this.listeners) {
      this.detachListeners()
    }
  },
  mounted () {
    if (state.getCurrentCompany().id !== '') {
      let query = df.collection(`receipts/${state.getCurrentCompany().id}/receipts`)
        .orderBy('issue_date_time', 'desc')

      const now = parseInt(
        (new Date().getTime() / 1000).toFixed(0)
      )

      const tmp = new Date()
      tmp.setDate(tmp.getDate() - 2)

      const before = parseInt(
        (tmp.getTime() / 1000).toFixed(0)
      )
      query = query.where('fiscalize', '==', true).where('jir', '==', '').where('issue_date_time', '>=', before).where('issue_date_time', '<=', now)

      const listener = query
        .onSnapshot((doc) => {
          doc.docs.forEach((rec) => {
            this.unfiskReceipts.push(rec.data())
          })

          if (doc.docs.length === 0) {
            this.unfiskReceipts = []
          }
        }
        )
      this.listeners.push(listener)
    }
  },
  computed: {
    title () {
      return state.getAppTitle()
    },
    titleFontSize () {
      const len = (this.title || '').length
      if (len <= 18) return '22px'
      if (len <= 30) return '18px'
      if (len <= 45) return '14px'
      return '12px'
    },
    listView () {
      return state.isListView()
    }
  },
  watch: {
    filter (val) {
      if (val !== this.topSearch) {
        this.topSearch = val
      }
    },
    search (val) {
      if (val !== this.topSearch) {
        this.topSearch = val
      }
    }
  },
  methods: {
    routeToReceipts () {
      this.$router.push({
        name: 'pointOfSale.receipts',
        params: {
        }
      })
    },
    changeView () {
      state.setListView(!state.isListView())
    },
    fireAddEvent () {
      if (state.events && Object.prototype.hasOwnProperty.call(state.events, this.$route.meta.addItemAction)) {
        state.events[this.$route.meta.addItemAction] = true
      }
    },
    searchItems (reset = false) {
      if (reset) {
        this.search = ''
      } else {
        if (this.topSearch) {
          this.search = this.topSearch
        } else {
          this.search = ''
        }
      }
    },
    filterItems (reset = false) {
      if (reset) {
        this.filter = ''
      } else {
        if (this.topSearch) {
          this.filter = this.topSearch
        } else {
          this.filter = ''
          this.search = '' // reset search on input event if there is no text
        }
      }
    }
  }
}
</script>
<style scoped>
/* TopBar Location Title */
.topbar-location-title {
  font-weight: 700 !important;
  background: linear-gradient(135deg,
    rgba(0, 179, 190, 1) 0%,
    rgba(57, 137, 201, 1) 50%,
    rgba(97, 84, 164, 1) 100%) !important;
  -webkit-background-clip: text !important;
  -webkit-text-fill-color: transparent !important;
  background-clip: text !important;
  letter-spacing: 0.5px !important;
  line-height: 1.25 !important;
  display: -webkit-box !important;
  -webkit-line-clamp: 3 !important;
  -webkit-box-orient: vertical !important;
  overflow: hidden !important;
  transition: font-size 0.2s ease !important;
}

/* TopBar Section Title */
.topbar-section-title {
  font-size: 18px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.5);
  font-style: italic;
  letter-spacing: 0.3px;
}

/* Glass Add Button - Soft Shadow Style */
.glass-add-btn {
  background: #00BCD4 !important;
  color: #ffffff !important;
  border-radius: 8px !important;
  border: none !important;
  box-shadow: 0 2px 8px rgba(0, 188, 212, 0.3) !important;
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: 13px !important;
  letter-spacing: 0.3px !important;
  padding: 8px 16px !important;
  height: 36px !important;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.glass-add-btn:hover {
  background: #00ACC1 !important;
  box-shadow: 0 4px 14px rgba(0, 188, 212, 0.45) !important;
  transform: translateY(-1px);
}

.glass-add-btn .v-icon {
  font-size: 18px !important;
  color: #ffffff !important;
}

.add-item-btn {
  background: rgba(0, 188, 212, 0.08) !important;
  color: #00838F !important;
  border: 1.2px solid #00b3be !important;
  box-shadow: none !important;
  border-radius: 8px !important;
  text-transform: none !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  letter-spacing: 0.3px !important;
  padding: 0 16px !important;
  height: 40px !important;
  white-space: nowrap;
}
.add-item-btn:hover {
  background: rgba(0, 179, 190, 0.12) !important;
}
.add-item-btn .v-icon {
  color: #00BCD4 !important;
  font-size: 17px !important;
}
</style>
